export const AI_GOVERNANCE_TABS = [
    { id: 'usage', label: 'Consumo', kind: 'production' },
    { id: 'users', label: 'Acesso', kind: 'production' },
    { id: 'knowledge', label: 'Base de conhecimento', kind: 'production' },
    { id: 'instructions', label: 'Instruções', kind: 'production' },
    { id: 'memory', label: 'Memória', kind: 'production' },
]

export const ACCESS_MATRIX_MODULES = ['projects']

export const MODULE_LABELS = {
    projects: 'Projetos',
    demands: 'Demandas',
    products: 'Produtos',
    purchasing: 'Compras',
    production: 'Produção',
    commercial: 'Comercial',
    finance: 'Financeiro',
    people: 'Pessoas',
    general: 'Geral',
}

export function moduleLabel(module) {
    if (!module) return '—'
    return MODULE_LABELS[module] || module
}

export function formatDuration(value) {
    const number = Number(value)
    if (!Number.isFinite(number)) return '—'
    if (number < 1000) return `${Math.round(number)} ms`
    return `${(number / 1000).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    })} s`
}

export function formatMeasure(stage) {
    if (!stage) return '—'
    if (stage.key === 'tool_rounds') {
        const number = Number(stage.avg)
        if (!Number.isFinite(number)) return '—'
        return number.toLocaleString('pt-BR', { maximumFractionDigits: 1 })
    }
    return formatDuration(stage.avg)
}

export function formatMeasureMax(stage) {
    if (!stage) return '—'
    if (stage.key === 'tool_rounds') {
        const number = Number(stage.max)
        if (!Number.isFinite(number)) return '—'
        return number.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
    }
    return formatDuration(stage.max)
}

export function formatTokens(value) {
    const number = Number(value)
    if (!Number.isFinite(number)) return '—'
    return Math.round(number).toLocaleString('pt-BR')
}

export function formatCost(value, currency = 'USD') {
    const number = Number(value)
    if (!Number.isFinite(number)) return '—'
    return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency,
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
    })
}

export function defaultUsageRange() {
    const until = new Date()
    const from = new Date()
    from.setDate(from.getDate() - 29)
    return {
        from: from.toISOString().slice(0, 10),
        until: until.toISOString().slice(0, 10),
    }
}
